import { hasPartyIdLength, partyIdLabel } from '@platform/components/ext_function';

export type PredefinedRule =
    | 'required'
    | 'requiredWithoutText'
    | 'requiredEmptySlot'
    | 'min3'
    | 'inn'
    | 'email'
    | 'phone'
    | 'fio';
type Validator = (val: string | null) => true | string;

export const predefined: Record<PredefinedRule, Validator> = {
    required: (val: string | any[] | null) => (Array.isArray(val) ? !!val.length : !!val) || 'Обязательно к заполнению',
    requiredWithoutText: (val: string | any[] | null) => (Array.isArray(val) ? !!val.length : !!val) || '',
    // required: (val) => !!val || 'Обязательно к заполнению',
    requiredEmptySlot: (val) => true,
    min3: (val) => (val && val?.toString()?.length > 2) || 'Минимально 3 символа',
    inn: (val) => (val && hasPartyIdLength(val)) || `Введите корректный ${partyIdLabel()}`,
    email: (val) =>
        !val ||
        (Array.isArray(val) && !val.length) ||
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(
            val
        ) ||
        'Введите корректный адрес эл. почты',
    phone: (val) =>
        (!!val && /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/gm.test(val)) ||
        'Введите корректный номер телефона',
    fio: (val) =>
        (!!val &&
            /^\s*([A-zА-я]{2,}(-[A-zА-я]{2,})?)\s+([A-zА-я]{2,}(-[A-zА-я]{2,})?)(\s+([A-zА-я]{2,}(-[A-zА-я]{2,})?))*\s*/gimu.test(
                val
            )) ||
        'Введито корректные ФИО',
};

export const customRuleMsg = (rule: Validator, message: string): Validator => {
    return (val) => {
        const applied = rule(val);
        if (typeof applied === 'string') return message;
        return applied;
    };
};

export const fabrics = {
    /**
     * Валидатор, проверяющий поле по заданному регулярному выражению
     * @param regex
     * @param message
     * @returns {function(*=)}
     */
    regex: {
        props: {
            regex: String,
            message: String,
        },
        func: ({ regex, message }: { regex: RegExp | string; message: string }) => {
            const regexp = regex instanceof RegExp ? regex : new RegExp(regex, 'i');
            return (val: string) => regexp.test(val) || message;
        },
    },

    function: {
        props: {
            body: String,
        },
        func: ({ body }: { body: string }) => {
            return new Function('val', body);
        },
    },
};

export type FabricRule = keyof typeof fabrics;
export type FabricRuleProps<T extends keyof typeof fabrics> = Parameters<(typeof fabrics)[T]['func']>[0];
